export function addFoundationValidation(value: any) {

const webregex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
  const emregex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig;
const phoneRegex = /^((\+?\d{1,4}[\s-]?)?(\(?\d{1,4}\)?[\s-]?)?[\d\s-]{5,})|([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
  let errors: any = {};
  if (!value.fName) {
    errors["fName"] = "Foundation name is required";
  }
  if (!value.fDetails) {
    errors["fDetails"] = "Foundation Details is required";
  }
  if (!value.fContactNumber) {
    errors["fContactNumber"] = "Contact Phone/Email is required";
  } else if (!phoneRegex.test(value.fContactNumber)) {
    errors["fContactNumber"] = "Enter a valid Contact Phone/Email";
  }
  if (!value.fWebsite) {
    errors["fWebsite"] = "Foundation Website is required";
  }  else if (!webregex.test(value.fWebsite)) {
    errors['fWebsite'] = 'Enter a valid Website with - http(s)';
}

  return errors;
}
